<script lang="ts">
  export let value = '';
  export let placeholder = '';
  export let showBorder = true;
  export let className = '';
</script>

<input bind:value {placeholder} class={className} style:border={showBorder ? '1px solid' : 'none'} />

<style>
  input:focus {
    outline: none;
  }
</style>
